"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    checkboxEmphases: ()=>checkboxEmphases,
    allowedCheckboxSizes: ()=>allowedCheckboxSizes,
    checkboxEmphasisVariants: ()=>checkboxEmphasisVariants,
    checkboxVariants: ()=>checkboxVariants,
    checkboxSizes: ()=>checkboxSizes
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const checkboxSizes = {
    16: {
        root: 'h-4 w-4',
        indicator: 'h-[14px] w-[14px]',
        labelSlot: 'text-body3'
    },
    20: {
        root: 'h-5 w-5',
        indicator: 'h-[18px] w-[18px]',
        labelSlot: 'text-body2'
    },
    24: {
        root: 'h-6 w-6',
        indicator: 'h-[22px] w-[22px]',
        labelSlot: 'text-body1'
    }
};
const allowedCheckboxSizes = Object.keys(checkboxSizes);
const checkboxEmphasisVariants = {
    regular: {
        labelSlot: 'text-primary-13 has-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1 border border-primary-6
    hover:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-primary-8
    hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-primary-8 
    hover:data-indeterminate:bg-primary-9 hover:data-indeterminate:border-primary-9

    disabled:bg-primary-2 disabled:text-primary-6 disabled:border-primary-5 disabled:hover:border-primary-5
    disabled:data-checked:bg-primary-2 disabled:data-checked:border-primary-2 
    disabled:hover:data-checked:bg-primary-2 disabled:hover:data-checked:border-primary-2
    disabled:data-indeterminate:bg-primary-2 disabled:data-indeterminate:border-primary-2 
    disabled:hover:data-indeterminate:bg-primary-2 disabled:hover:data-indeterminate:border-primary-2
    `
    },
    medium: {
        labelSlot: 'text-primary-13 has-disabled:text-primary-6',
        root: `
    text-primary-1 bg-primary-1/60 border border-primary-6
    hover:border-primary-10 focus-visible:outline-primary-8

    data-checked:bg-primary-8 data-checked:border-primary-8
    hover:data-checked:bg-primary-9 hover:data-checked:border-primary-9

    data-indeterminate:bg-primary-8 data-indeterminate:border-primary-8
    hover:data-indeterminate:bg-primary-9 hover:data-indeterminate:border-primary-9 

    disabled:bg-primary-1/60 disabled:text-primary-6 disabled:border-primary-5 disabled:hover:border-primary-5
    disabled:data-checked:bg-primary-1/60 disabled:data-checked:border-primary-1/60 
    disabled:hover:data-checked:bg-primary-1/60 disabled:hover:data-checked:border-primary-1/60
    disabled:data-indeterminate:bg-primary-1/60 disabled:data-indeterminate:border-primary-1/60 
    disabled:hover:data-indeterminate:bg-primary-1/60 disabled:hover:data-indeterminate:border-primary-1/60
    `
    },
    bold: {
        labelSlot: 'text-primary-1 has-disabled:text-primary-1/40',
        root: `
    text-primary-8 bg-primary-1/20 border border-primary-1/40
    hover:border-primary-1 focus-visible:outline-primary-1

    data-checked:bg-primary-1 data-checked:border-primary-1
    hover:data-checked:bg-primary-1/80 hover:data-checked:border-primary-1/80

    data-indeterminate:bg-primary-1 data-indeterminate:border-primary-1
    hover:data-indeterminate:bg-primary-1/80 hover:data-indeterminate:border-primary-1/80
    
    disabled:bg-primary-1/20 disabled:text-primary-1/40 disabled:border-primary-1/20 disabled:hover:border-primary-1/20
    disabled:data-checked:bg-primary-1/20 disabled:data-checked:border-primary-1/20 
    disabled:hover:data-checked:bg-primary-1/20 disabled:hover:data-checked:border-primary-1/20
    disabled:data-indeterminate:bg-primary-1/20 disabled:data-indeterminate:border-primary-1/20 
    disabled:hover:data-indeterminate:bg-primary-1/20 disabled:hover:data-indeterminate:border-primary-1/20
    `
    }
};
const checkboxEmphases = Object.keys(checkboxEmphasisVariants);
const checkboxVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        labelSlot: 'has-disabled:cursor-not-allowed flex cursor-pointer flex-row gap-2',
        root: 'hover:shadow-input-hover data-checked:transition data-indeterminate:transition group relative inline-flex cursor-pointer items-center justify-center rounded-sm align-middle transition focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:hover:shadow-none',
        indicator: 'data-checked:transition data-indeterminate:transition inline-flex items-center justify-center overflow-hidden align-middle transition',
        icon: 'data-checked:transition data-indeterminate:transition transition'
    },
    variants: {
        size: checkboxSizes,
        emphasis: checkboxEmphasisVariants,
        isCheckboxGroup: {
            true: {}
        },
        layout: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            isCheckboxGroup: true,
            layout: 'vertical',
            class: {
                labelSlot: 'w-full py-1'
            }
        }
    ],
    defaultVariants: {
        emphasis: 'regular',
        size: '20',
        layout: 'vertical'
    }
});
exports.allowedCheckboxSizes = __webpack_exports__.allowedCheckboxSizes;
exports.checkboxEmphases = __webpack_exports__.checkboxEmphases;
exports.checkboxEmphasisVariants = __webpack_exports__.checkboxEmphasisVariants;
exports.checkboxSizes = __webpack_exports__.checkboxSizes;
exports.checkboxVariants = __webpack_exports__.checkboxVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "allowedCheckboxSizes",
    "checkboxEmphases",
    "checkboxEmphasisVariants",
    "checkboxSizes",
    "checkboxVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
